import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const DiscountsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Discounts Management
      </Typography>
      <Alert severity="info">
        This page is currently under maintenance. Grid component conversion in progress.
      </Alert>
    </Box>
  );
};

export default DiscountsPage; 